// firebase/config.ts
import { initializeApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  setPersistence,
  browserSessionPersistence,
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

// Your real config (keep yours exactly)
const firebaseConfig = {
  apiKey: "AIzaSyDxhgracHL9_p-sjTJPWi5iRYI-pHAm7h4",
  authDomain: "osfnschools.firebaseapp.com",
  projectId: "osfnschools",
  storageBucket: "osfnschools.firebasestorage.app",
  messagingSenderId: "271346794239",
  appId: "1:271346794239:web:47706536312ded1eea16ca",
  measurementId: "G-PP58SVHNDW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
void setPersistence(auth, browserSessionPersistence).catch((e) => {
  console.error('[Auth] setPersistence failed', e);
});
// Deterministic auth persistence: avoids "old user still signed in" surprises.
// Session persistence survives reloads in the same tab session, but not full browser restarts.
void setPersistence(auth, browserSessionPersistence).catch((e) => {
  console.error('[Auth] setPersistence failed', e);
});

const db = getFirestore(app);
const functions = getFunctions(app);

// Google provider
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

export { auth, db, app, functions, googleProvider };